/**
 * Client for the `call` edge function: placing one outbound call. The function
 * picks the dialer for the number's carrier, and the dialer is where billing,
 * the limits and the call log live — no component asks a dialer directly.
 * (`call.service.ts` is Call History's read of `call_logs`, not this function.)
 * Keep in sync with `supabase/functions/call/` and `utils/phone-number-rules.ts`.
 */

import { api } from "@/lib/api-client";

export interface CreateCallBody {
  workspace_id: string;
  /** As it is dialled: E.164 with the `+` optional, and no separators. */
  to_number: string;
  /** One of the workspace's numbers, exactly as the numbers list returned its `phone_number`. */
  from_number: string;
  agent_id: string;
  /** Values for the `{{variables}}` of the agent's prompt; left out when there are none. */
  dynamic_variables?: Record<string, string>;
}

/** A call as the function answers it. */
export interface Call {
  /** `call_logs.id`. */
  id: string;
  /** Where the call starts: `queued`. */
  status: string;
  to_number: string;
  from_number: string;
  agent_id: string;
  agent_name: string;
}

/** Answers once the call exists, not once it is picked up. */
export const createCall = (body: CreateCallBody) => api.post<Call>("/call", body);
